import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ModalService } from "../../components/modal/service/modal.service";
import { CategoryFormComponent } from "./category-form/category-form.component";
import { CategoryService } from "./category.service";

import Swal from "sweetalert2";
import { Observable } from "rxjs";

@Component({
  selector: "app-category",
  imports: [CommonModule, RouterModule],
  templateUrl: "./category.component.html",
  styleUrl: "./category.component.scss",
})
export class CategoryComponent implements OnInit {
  items$: Observable<any[]> | undefined;

  constructor(
    @Inject(CategoryService) public categoryService: CategoryService,
    private modalService: ModalService
  ) {}

  async ngOnInit() {
    await this.loadFirstPage();
    this.categoryService.action$.subscribe((action) => {
      this.loadFirstPage();
    });
  }

  async loadFirstPage() {
    this.items$ = this.categoryService.getFirstPage();
  }

  async nextPage() {
    this.items$ = this.categoryService.getNextPage();
  }

  async prevPage() {
    this.items$ = this.categoryService.getPreviousPage();
  }

  openModal() {
    this.modalService.openModal(
      CategoryFormComponent,
      "Cadastro de Categoria",
      "modal-sm"
    );
  }

  async editar(id: string) {
    this.modalService.openModal(
      CategoryFormComponent,
      "Cadastro de Categoria",
      "modal-sm",
      { id }
    );
  }

  async delete(id: string) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Excluir?",
        text: "Deseja realmente excluir essa categoria?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim!",
        cancelButtonText: "Não, cancelar!",
        reverseButtons: true,
      })
      .then(async (result: any) => {
        if (result.value) {
          await this.categoryService.delete(id);
        }
      });
  }
}
